import { ArtistsOptions } from '../models/artists';
import { VenuesOptions } from '../models/venues';

// Sanitize user-provided search strings to reduce risk of injection attacks.
// - Trims and normalizes whitespace
// - Removes control characters and common SQL meta tokens ("--", ";", block comments)
// - Caps maximum length
const MAX_QUERY_LENGTH = 100;
const sanitizeQuery = (input?: string): string => {
  // eslint-disable-next-line no-control-regex
  const raw = (input ?? '').replace(/[\u0000-\u001F\u007F]/g, ' ');
  // Remove common SQL injection tokens
  const withoutSqlTokens = raw
    .replace(/--/g, ' ') // inline comment
    .replace(/;/g, ' ') // statement terminator
    .replace(/\/\*[\s\S]*?\*\//g, ' '); // block comment

  // Collapse whitespace and trim
  const collapsed = withoutSqlTokens.replace(/\s+/g, ' ').trim();
  // Enforce a reasonable max length
  return collapsed.length > MAX_QUERY_LENGTH ? collapsed.slice(0, MAX_QUERY_LENGTH) : collapsed;
};

// Build query string for venues API
export const buildVenuesQuery = (options?: VenuesOptions): string => {
  const params = new URLSearchParams();
  params.set('$top', String(options?.top ?? 100));
  const searchString = sanitizeQuery(options?.searchString);
  if (searchString.length > 0) {
    params.set('searchString', searchString);
  }
  const query = params.toString();
  return query ? `?${query}` : '';
};

// Build query string for artists API (same structure)
export const buildArtistsQuery = (options?: ArtistsOptions): string => {
  const params = new URLSearchParams();
  params.set('$top', String(options?.top ?? 100));
  const searchString = sanitizeQuery(options?.searchString);
  if (searchString.length > 0) {
    params.set('searchString', searchString);
  }
  const query = params.toString();
  return query ? `?${query}` : '';
};
